import { Component, Input } from '@angular/core';
import { RouterService } from '../services/router.service';

@Component({
  selector: 'app-route-sender-data',
  templateUrl: './route-sender-data.component.html',
  styleUrls: ['./route-sender-data.component.css']
})
export class RouteSenderDataComponent {

  @Input() itSystem: any;
  @Input() authority: any;

    constructor(private routerService: RouterService){}
  itSystemData: any;

  ngOnInit(){ 
        this.routerService.getOrganisation(this.itSystem.userSystemCVR).then(data =>{
            this.itSystemData = data;
     })
  }

}
